import Factory from '../utils/factory'
import Address from '../Address'

export default Factory({
  id: null,
  contact: {
    name: null,
    phone: null,
    email: null,
    upsell: null,
    address: Address(),
    company: null,
    tags: [],
  },
  scopes: [],
})
